import { yupResolver } from "@hookform/resolvers/yup";
import { cn } from "@omni/utils/styles";
import { useEffect } from "react";

import { PasswordField } from "@/components/Form/RHF/FormFields/PasswordField/passwordField.component";
import { useOmniForm } from "@/components/Form/RHF/Utils/useOmniForm";
import { Col } from "@/components/General/Grid/col.component";
import { Container } from "@/components/General/Grid/container.component";
import { Row } from "@/components/General/Grid/row.component";
import { Messages } from "@/components/General/Messages/messages.container";
import { clearMessageById } from "@/redux/modules/value/messages/messages.utils";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { FormInfoProvider } from "@/utils/forms/formInfo.provider";
import { OmniFormContextProvider } from "@/utils/forms/omniForm.provider";

import {
    EditPasswordFormValidationSchema,
    EditPasswordFormValues
} from "./editPassword.schema";

const FORM_ID = "profileEditPasswordForm";

type Props = {
    onSubmit: (oldPassword: string, newPassword: string) => void;
};

const EditPasswordForm = ({ onSubmit }: Props) => {
    const { t } = useGranite();

    const methods = useOmniForm({
        mode: "onBlur",
        reValidateMode: "onBlur",
        defaultValues: {
            oldPassword: "",
            newPassword: "",
            newPasswordRepeat: ""
        },
        resolver: yupResolver(EditPasswordFormValidationSchema)
    });

    useEffect(() => {
        clearMessageById("edit-password-failure");
    }, []);

    const onFormSubmit = ({
        oldPassword,
        newPassword
    }: EditPasswordFormValues) => {
        clearMessageById("edit-password-failure");
        onSubmit?.(oldPassword, newPassword);
    };

    return (
        <div>
            <Messages messageid={"edit-password-failure"} />
            <FormInfoProvider
                formId={FORM_ID}
                withNeverbounce={false}
            >
                {() => (
                    <OmniFormContextProvider {...methods}>
                        <form
                            id={FORM_ID}
                            onSubmit={methods.handleSubmit(onFormSubmit)}
                        >
                            <Container className={cn("tw:px-0")}>
                                <Row>
                                    <Col>
                                        <PasswordField<EditPasswordFormValues>
                                            name="oldPassword"
                                            label={t(
                                                "general.form.oldPassword.label"
                                            )}
                                            required
                                            autoComplete={"off"}
                                        />
                                        <PasswordField<EditPasswordFormValues>
                                            name="newPassword"
                                            label={t(
                                                "general.form.newPassword.label"
                                            )}
                                            required
                                            autoComplete={"off"}
                                        />
                                        <PasswordField<EditPasswordFormValues>
                                            name="newPasswordRepeat"
                                            label={t(
                                                "general.form.newPasswordRepeat.label"
                                            )}
                                            required
                                            autoComplete={"off"}
                                        />
                                    </Col>
                                </Row>
                            </Container>
                        </form>
                    </OmniFormContextProvider>
                )}
            </FormInfoProvider>
        </div>
    );
};

export default EditPasswordForm;
